import Manage from '@components/LocalMerchant/SiDa/GroupManage/Manage'
import Home from '@components/LocalMerchant/SiDa/GroupManage/Home'
import Member from '@components/LocalMerchant/SiDa/GroupManage/Member'
import MemberCreate from '@components/LocalMerchant/SiDa/GroupManage/MemberCreate'
import Schedule from '@components/LocalMerchant/SiDa/GroupManage/Schedule'
import Setting from '@components/LocalMerchant/SiDa/GroupManage/Setting'
import ScheduleTool from '@components/LocalMerchant/SiDa/ScheduleTool'
import GroupInvite from '@components/LocalMerchant/SiDa/GroupInvite'
import GroupApply from '@components/LocalMerchant/SiDa/GroupApply'
import GroupStatus from '@components/LocalMerchant/SiDa/GroupStatus'
import GroupRegister from '@components/LocalMerchant/SiDa/GroupRegister'
import CeremonialMerchantInvite from '@components/ActivityPage/CeremonialMerchantInvite'

export default [
  {
    path: 'scheduleTool',
    component: ScheduleTool,
    stat: '档期'
  },
  {
    path: 'groupHome',
    component: Home,
    stat: '团队管理/首页'
  },
  {
    path: 'groupManage',
    component: Manage,
    stat: '团队管理/团队管理'
  },
  {
    path: 'groupMember',
    component: Member,
    stat: '团队管理/团队成员'
  },
  {
    path: 'groupMember/create',
    component: MemberCreate,
    stat: '团队管理/团队成员/创建成员'
  },
  {
    path: 'groupSchedule',
    component: Schedule,
    stat: '团队管理/团队档期'
  },
  {
    path: 'groupSetting',
    component: Setting,
    stat: '团队管理/团队设置'
  },
  {
    path: 'groupInvite',
    component: GroupInvite,
    stat: '团队管理/团队邀请'
  },
  // 司仪团队才有
  {
    path: 'groupApply',
    component: GroupApply,
    stat: '团队管理/团队申请'
  },
  {
    path: 'groupStatus',
    component: GroupStatus,
    stat: '团队管理/团队状态'
  },
  {
    path: 'siyiGroup',
    component: GroupRegister,
    stat: '司仪团队注册'
  },
  {
    path: 'CeremonialMerchantInvite',
    component: CeremonialMerchantInvite,
    stat: '四大商家邀请'
  }
]
